<template>
<div>
    <Breadcrumbs main="Vendor" title="RFQ" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    
                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <div class="d-flex flex-wrap" style="gap: 20px;">
                                    <b-input-group class="datatable-btn" style="width: 340px;">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #563EE0; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                        <feather type="filter"></feather>
                                        <h7>Filter</h7>
                                    </div>

                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="filterShow || statusSelected ||  start_date || end_date  || categorySelected">
                                        <feather type="x"></feather>
                                        <h7>Clear All</h7>
                                    </div>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div class="row mt-2" v-if="filterShow">
                            <div class="col-md-12">
                                <div class="grid-container mt-sm-0">
                                    <div class="grid-item">
                                        <datepicker placeholder="Start Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="start_date"></datepicker>
                                    </div>
                                    <div class="grid-item">
                                        <datepicker placeholder="End Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="end_date"></datepicker>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="categorySelected" :options="formattedCategories"></b-form-select>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="statusSelected" :options="formattedOptions"></b-form-select>
                                    </div>
                                  
                                </div>
                            </div>
                        </div>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue" style="margin-top: 22px;">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(rfp_id)="data">
                                        <div style="display: flex; flex-direction: column; max-width: 250px;">
                                            <router-link :to="`/procurement/rfp/${data.item.id}`" class="link-style">
                                                {{ data.item.rfp_id }}
                                            </router-link>
                                            <div style="margin-top: 4px;" v-if="data.item.title">
                                                {{ truncateText(data.item.title, 100) }} 
                                            </div>
                                        </div>
                                    </template>

                                    <template #cell(rfp_category)="data">
                                        <span v-if="data.item.rfp_category !== null">
                                            {{ data.item.rfp_category.title }}
                                        </span>
                                    </template>

                                    <template #cell(project)="data">
                                        <span>
                                            <span v-if="data.item.project !== null">
                                                {{ truncateText(data.item.project.title, 50) }}
                                            </span>
                                            <span v-else>N/A</span>
                                        </span>
                                    </template>

                                    <template #cell(status)="row">
                                        <span  v-if="row.value == 'INITIATED'">
                                            <b-badge pill variant="warning" >{{ row.value }}</b-badge>
                                        </span>
                                        <span  v-if="row.value == 'COMPLETED'">
                                            <b-badge pill variant="success" >{{ row.value }}</b-badge>
                                        </span>
                                        <span  v-if="row.value == 'WORKING'">
                                            <b-badge pill variant="info" >{{ row.value }}</b-badge>
                                        </span>
                                        <span v-if="row.value == 'APPROVED'">
                                            <b-badge pill variant="primary" >{{ row.value }}</b-badge>
                                        </span>
                                    </template>

                                  

                                    <!-- <template #cell(form_submit)="data">
                                        <span v-if="data.item.form_generated == true">
                                            <router-link :to="`/procurement/rfp/submit-form/${data.item.id}`">
                                                <b-button variant="secondary" style="width: 125px;">View Form</b-button>
                                            </router-link>
                                        </span>
                                    </template> -->

                                    <template #cell(form_generated)="data">
                                        <span v-if="data.item.form_generated == true">
                                            <router-link :to="`/procurement/rfp/submit-form/${data.item.id}`">
                                                <b-button variant="secondary" style="width: 125px;">View Form</b-button>
                                            </router-link>
                                        </span>
                                    </template>

                                    <template #cell(active_status)="data">
                                        <div v-if="data.item.active == true"  style="cursor: pointer;">
                                            <b-badge pill variant="success" >Active</b-badge>
                                        </div>
                                        <div v-if="data.item.active == false"  style="cursor: pointer;">
                                            <b-badge pill variant="danger" >Inactive</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteRFP(data.item.id)" title="Delete"></feather>
                                            <router-link :to="`/procurement/rfp/edit/${data.item.id}`">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit"></feather>
                                            </router-link>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this RFP?</div>
    </b-modal>

    <!-- Update Status -->
    <b-modal id="modal-prevent-closing-status" ref="modal" title="Update RFP Status" @show="resetModal" @hidden="resetModal" @ok="handleStatusOk">
        <form ref="form" @submit.stop.prevent="handleStatusSubmit">
            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="selectedStatus" :options="statuses_for_update"></b-form-select>
            </b-form-group>
        </form>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
    components: {
        Datepicker
    },

    data() {
        return {
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'rfp_id',
                    label: 'RFP ID',
                    sortable: true
                },
                {
                    key: 'rfp_category',
                    label: 'Category',
                    sortable: true
                },
                {
                    key: 'project',
                    label: 'Project',
                    sortable: true
                },
                {
                    key: 'deadline',
                    label: 'Deadline',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
               
              
                {
                    key: 'form_generated',
                    label: 'Form',
                    sortable: true,
                    class: 'text-center'
                },
               
                
            ],
            start_date: null,
            end_date: null,
            categorySelected: '',
            statusSelected: '',
            activeSelected: '',
            filterShow: false,
            filter: null,
            rfp_category_id: '',
            delete_value: null,
            rfp_update_id: '',
            statuses_for_update: ['INITIATED', 'APPROVED', 'WORKING', 'COMPLETED'],
            statuses: [
                {
                    id: 1,
                    name: 'Initiated',
                    value: 'INITIATED'
                },
                {
                    id: 2,
                    name: 'Approved',
                    value: 'APPROVED'
                },
                {
                    id: 3,
                    name: 'Working',
                    value: 'WORKING',
                },
                {
                    id: 4,
                    name: 'Completed',
                    value: 'COMPLETED'
                }
            ],
            active_list: [
                {
                    id: 1,
                    name: 'Active',
                    value: 'True'
                },
                {
                    id: 2,
                    name: 'Inactive',
                    value: 'False'
                }
            ],
            selectedStatus: '',
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],
            lastScrollY: 0,
            initialLoad: true,
            isModifyingDate: false
        };
    },

    computed: {
        ...mapState({
            items: state => state.rfp.rfp,
            count: state => state.rfp.count,
            rfp_category_list: state => state.rfp.rfp_category,
            loading: state => state.rfp.submitLoading,
            error: state => state.rfp.submitError
        }),

        formattedOptions() {
            return [{
                    value: '',
                    text: 'Select Status',
                    disabled: true
                },
                ...this.statuses.map(status => ({
                    value: status.value,
                    text: status.name
                }))
            ];
        },

        formattedActive() {
            return [{
                    value: '',
                    text: 'Select Active Status',
                    disabled: true
                },
                ...this.active_list.map(status => ({
                    value: status.value,
                    text: status.name
                }))
            ];
        },

        formattedCategories() {
            return [{
                    value: '',
                    text: 'Select Category',
                    disabled: true
                },
                ...this.rfp_category_list.map(status => ({
                    value: status.id,
                    text: status.title
                }))
            ];
        }
    },

    mounted() {
        this.$store.dispatch("rfp/fetchRFPCategory");

        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {

                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });

                this.fetchInitial();
            } else {

                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);

                this.fetchInitial();
            }
        }
    },

    watch: {
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/vendor/rfq',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("rfp/fetchRFP", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.statusSelected,
                    category: this.categorySelected,
                    active: this.activeSelected
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/vendor/rfq',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    }
                });
                this.perPage = newperPage
                this.$store.dispatch("rfp/fetchRFP", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.statusSelected,
                    category: this.categorySelected,
                    active: this.activeSelected
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        start_date(newVal, oldVal) {
            if (!this.initialLoad) {
                if (!this.isModifyingDate) {
                    this.isModifyingDate = true;
                    if (this.start_date !== null) {
                        this.start_date = moment(String(this.start_date)).format("YYYY-MM-DD");

                        this.$store.dispatch("rfp/fetchRFP", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            search_term: this.filter,
                            status: this.statusSelected,
                            category: this.categorySelected,
                            active: this.activeSelected
                        }).then(() => {
                            this.currentPage = 1
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false; 
                        });
                    } else {
                        this.$store.dispatch("rfp/fetchRFP", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            search_term: this.filter,
                            status: this.statusSelected,
                            category: this.categorySelected,
                            active: this.activeSelected
                        }).then(() => {
                            this.currentPage = 1
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false; 
                        });
                    }
                }
            }
        },

        end_date(newVal, oldVal) {
            if (!this.initialLoad) {
                if (!this.isModifyingDate) {
                    this.isModifyingDate = true;
                    if (this.end_date !== null) {
                        this.end_date = moment(String(this.end_date)).format("YYYY-MM-DD");
                        this.$store.dispatch("rfp/fetchRFP", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            search_term: this.filter,
                            status: this.statusSelected,
                            category: this.categorySelected,
                            active: this.activeSelected
                        }).then(() => {
                            this.currentPage = 1
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false; 
                        });
                    } else {
                        this.$store.dispatch("rfp/fetchRFP", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            search_term: this.filter,
                            status: this.statusSelected,
                            category: this.categorySelected,
                            active: this.activeSelected
                        }).then(() => {
                            this.currentPage = 1
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false; 
                        });
                    }
                }
            }
        },

        statusSelected(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("rfp/fetchRFP", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.statusSelected,
                    category: this.categorySelected,
                    active: this.activeSelected
                }).then(() => {
                    this.currentPage = 1
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        filter(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("rfp/fetchRFP", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.statusSelected,
                    category: this.categorySelected,
                    active: this.activeSelected
                }).then(() => {
                    this.currentPage = 1
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        categorySelected(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("rfp/fetchRFP", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.statusSelected,
                    category: this.categorySelected,
                    active: this.activeSelected
                }).then(() => {
                    this.currentPage = 1
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        activeSelected(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("rfp/fetchRFP", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.statusSelected,
                    category: this.categorySelected,
                    active: this.activeSelected
                }).then(() => {
                    this.currentPage = 1
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        }
    },

    methods: {
        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },

        fetchInitial() {
            this.$store.dispatch("rfp/fetchRFP", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                start_date: this.start_date,
                end_date: this.end_date,
                search_term: this.filter,
                status: this.statusSelected,
                category: this.categorySelected,
                active: this.activeSelected
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },

        clearFilter() {
            this.filterShow = false,
            this.filter = null,
            this.statusSelected = '',
            this.start_date = null,
            this.end_date = null,
            this.categorySelected = '',
            this.activeSelected = ''
        },

        handleScroll(event) {
            // Calculate the new scroll position
            const scrollAmount = event.deltaY * this.scrollSpeedFactor;
            window.scrollBy({
                top: scrollAmount,
                behavior: 'smooth' // Smooth scroll
            });

            // Prevent default scrolling
            event.preventDefault();
        },

        resetModal() {
            this.selectedStatus = ''
        },

        getStatus(status, id) {
            this.rfp_update_id = id
            this.selectedStatus = status
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        deleteRFP(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("rfp/deleteRFP", {
                delete: this.delete_value,
                page: this.$route.query.page,
                perPage: this.$route.query.perPage,
                start_date: this.start_date,
                end_date: this.end_date,
                search_term: this.filter,
                status: this.statusSelected,
                category: this.categorySelected,
                active: this.activeSelected
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        activeStatus(id) {
            this.$store.dispatch("rfp/toggleRFPStatus", {
                id: id,
                page: this.$route.query.page,
                perPage: this.$route.query.perPage,
                start_date: this.start_date,
                end_date: this.end_date,
                search_term: this.filter,
                status: this.statusSelected,
                category: this.categorySelected,
                active: this.activeSelected

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.udate_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        handleStatusOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleStatusSubmit()
        },

        handleStatusSubmit() {
            // alert(JSON.stringify(this.rfp_update_id))
            // alert(JSON.stringify(this.selectedStatus))
            this.$store.dispatch("rfp/updateRfpStatus", {
                id: this.rfp_update_id,
                status_for_change: this.selectedStatus,
                page: this.$route.query.page,
                perPage: this.$route.query.perPage,
                start_date: this.start_date,
                end_date: this.end_date,
                search_term: this.filter,
                status: this.statusSelected,
                category: this.categorySelected,
                active: this.activeSelected

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-status')
            })
        }
    }
};
</script>

<style scoped>
.header-mobile {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (max-width: 460px) {
    .header-mobile {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: start;
    }
}
</style>
